export default __webpack_public_path__ + "static/media/features-icon.56b2c3c8.png";